"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFetchOptions = getFetchOptions;
exports["default"] = exports.setXsrfToken = exports.resetXsrfToken = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

require("isomorphic-fetch");

var _runtimeConfigHelper = require("./helpers/runtime-config-helper");

var _brandHelper = require("./helpers/brand-helper");

var _fetchHelper = require("./helpers/fetch-helper");

var _urlHelper = require("./helpers/url-helper");

var _currentLanguageHelper = _interopRequireDefault(require("./helpers/current-language-helper"));

var _apiKeyHelper = require("./helpers/api-key-helper");

var _lodash = require("lodash");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

if (typeof window !== 'undefined') {
  window._xsrfToken = window._xsrfToken || null;
} // wrapper for every fetch action
// adding 'simpleCall' options. With this option, it would not auto inject
// any requests with X-XSRF-TOKEN.


var fetchWrapper = function fetchWrapper(url) {
  var options,
      fetchOptions,
      method,
      xsrfDisabled,
      xsrftokenName,
      xsrftokenHostedBrands,
      fetchXsrfTokenSiteName,
      xsrfPreAuth,
      result,
      _args = arguments;
  return _regenerator["default"].async(function fetchWrapper$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};

          if (!(url.indexOf('credit_card/auth') < 0 && !options.simpleCall)) {
            _context.next = 23;
            break;
          }

          fetchOptions = (0, _lodash.pick)(options, ['method', 'headers', 'body', 'redirect', 'signal', 'follow', 'timeout', 'compress', 'size', 'agent']); // TODO - remove this feature on next major update

          if (options.fetchOptions) {
            if (process.env.NODE_ENV !== 'production') {
              console.warn('fetch(url, { fetchOptions, ...otherOptions }) has been deprecated, instead pass in a flat object containing all your required options to fetch as the second argument');
            }

            fetchOptions = _objectSpread({}, fetchOptions, {}, options.fetchOptions);
          }

          options = getFetchOptions(_objectSpread({}, options, {
            url: url,
            fetchOptions: fetchOptions
          }));
          method = (options.method || 'GET').toUpperCase();
          xsrfDisabled = (0, _runtimeConfigHelper.getRuntimeConfig)()._fetchXsrfTokenDisabled;

          if (!(method !== 'GET' && xsrfDisabled !== true)) {
            _context.next = 23;
            break;
          }

          xsrftokenName = (0, _runtimeConfigHelper.getRuntimeConfig)()._fetchXsrfTokenHeaderName || 'X-XSRF-TOKEN';

          if (!getXsrfToken()) {
            _context.next = 13;
            break;
          }

          options.headers[xsrftokenName] = getXsrfToken();
          _context.next = 23;
          break;

        case 13:
          // Do the preauth call when the setting is enabled (this is used to override the default check for hosted brands)
          xsrftokenHostedBrands = (0, _runtimeConfigHelper.getRuntimeConfig)()._fetchXsrfTokenHostedBrands || !(0, _brandHelper.isHostedBrand)();

          if (!xsrftokenHostedBrands) {
            _context.next = 23;
            break;
          }

          fetchXsrfTokenSiteName = (0, _runtimeConfigHelper.getRuntimeConfig)()._fetchXsrfTokenSiteName;

          if (!fetchXsrfTokenSiteName) {
            _context.next = 23;
            break;
          }

          xsrfPreAuth = (0, _urlHelper.getUrl)((0, _runtimeConfigHelper.getRuntimeConfig)()._fetchXsrfTokenSiteName, (0, _runtimeConfigHelper.getRuntimeConfig)()._fetchXsrfTokenEndpoint);
          _context.next = 20;
          return _regenerator["default"].awrap(fetch(xsrfPreAuth, {
            method: 'POST',
            headers: {
              'Accept-Language': 'en-us'
            },
            credentials: 'include'
          }));

        case 20:
          result = _context.sent;
          setXsrfToken(result.headers.get(xsrftokenName));
          options.headers[xsrftokenName] = getXsrfToken();

        case 23:
          return _context.abrupt("return", fetch(url, options));

        case 24:
        case "end":
          return _context.stop();
      }
    }
  });
};

var getXsrfToken = function getXsrfToken() {
  return window && window._xsrfToken;
};

var resetXsrfToken = function resetXsrfToken() {
  if (typeof window !== 'undefined') {
    window._xsrfToken = undefined;
  }
};

exports.resetXsrfToken = resetXsrfToken;

var setXsrfToken = function setXsrfToken(xsrfToken) {
  if (typeof window !== 'undefined') {
    window._xsrfToken = xsrfToken;
  }
};

exports.setXsrfToken = setXsrfToken;

function getFetchOptions(options) {
  var incomingFetchOptions = options.fetchOptions || {};

  var fetchOptions = _objectSpread({
    headers: {}
  }, incomingFetchOptions); // Exclude credentials for cdn calls


  if ((0, _urlHelper.isKnownCdnUrl)(options.url)) {
    fetchOptions.credentials = 'same-origin';
  }

  if (!options.skipCredentials) {
    // Include credentials header / cookies in the fetch
    fetchOptions.credentials = 'include'; // set current Language in request

    var language = (0, _currentLanguageHelper["default"])();
    fetchOptions.headers = _objectSpread({}, fetchOptions.headers, {
      'Accept-Language': language
    });
  } // Automatic resolve api key's


  if (options.apikey && options.apikey !== '') {
    var resolvedKey = (0, _apiKeyHelper.getApiKey)(options.apikey);

    if (resolvedKey) {
      fetchOptions.headers = _objectSpread({}, fetchOptions.headers, {
        'x-api-key': resolvedKey
      });
    }
  }

  if (_fetchHelper.globalModifyHeader && (0, _lodash.isFunction)(_fetchHelper.globalModifyHeader) && !fetchOptions.simpleCall) {
    (0, _fetchHelper.globalModifyHeader)(fetchOptions.headers);
  }

  return fetchOptions;
}

var _default = fetchWrapper;
exports["default"] = _default;